//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
// import './style.scss'
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const struggle = useStore((state) => state.struggle);
  const setStruggle = useStore((state) => state.setStruggle);

  const [next, setNext] = useState(struggle.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setStruggle(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.struggle.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={struggle} onChange={handleChange}>
          <MultiOption value={'Staying motivated'}>
            <span>🏆</span>
            {t('onboarding.struggle.options.motivated')}
          </MultiOption>
          <MultiOption value={'Reducing portion sizes'}>
            <span>🥘</span>
            {t('onboarding.struggle.options.portionSizes')}
          </MultiOption>
          <MultiOption value={'Lack of free time'}>
            <span>⏰</span>
            {t('onboarding.struggle.options.freeTime')}
          </MultiOption>
          <MultiOption value={'Resisting cravings'}>
            <span>🍕</span>
            {t('onboarding.struggle.options.cravings')}
          </MultiOption>
          <MultiOption value={'Knowing what to eat'}>
            <span>🥣</span>
            {t('onboarding.struggle.options.whatToEat')}
          </MultiOption>
          <MultiOption value={'Something else'}>
            <span>☕️</span>
            {t('onboarding.struggle.options.somethingElse')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.struggle.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'struggle',
              answer: struggle.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
